const cepMask = () => [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];

export default cepMask;



// WEBPACK FOOTER //
// ./src/components/Masks/CEP.js